export enum StatisticType {
  ENTERPRISES = 'enterprises',
  ARTICLES = 'articles',
  UNITS = 'units',
  CITIES = 'cities',
  CUSTOMERS = 'customers',
  FEATURES = 'features',
}
